import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";

import DatePicker from "react-datepicker";
import { components } from "react-select";
import Select from "react-select";
import { CircularAvatar, DropDown } from "../../commons";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import {
  FilterTextType,
  MultiSelectDataType,
} from "../../../commonTypes/hrmsTypes";
import { MeetUpFilterFieldsType } from "../../../redux/clientDirectory/clientDirectoryType";

const MEET_UP_STATUS = [
  { label: "Completed", value: "completed" },
  { label: "Pending", value: "pending" },
];

type DropDownOptionType = {
  value: string | null;
  label: string;
};

type AppProps = {
  toggle: boolean;
  type?: string;
  setText: (data: string) => void;
  setoffset: any;
  setToggle: (data: boolean) => void;
  finalUserList: DropDownOptionType[];
  fetching: boolean;
  filterValue: any;
  setFilterValue: any;
  multiSelectData: MeetUpFilterFieldsType;
  handleApplyFilter: () => void;
  handleFilterClear: () => void;
  limit: number;
};

const AllClientMeetUpFilter = ({
  toggle,
  setToggle,
  finalUserList,
  fetching,
  handleApplyFilter,
  handleFilterClear,
  multiSelectData,
  filterValue,
  setFilterValue,
  setText,
  setoffset,
  limit,
  type,
}: AppProps) => {
  const [leadText, setLeadText] = useState<string>("");
  const [meetingText,setMeetingText] = useState<string>("")
  const checkBottom = () => {
    setoffset((prv: any) => prv + limit);
  };

  const filterCount: number = Object.values(multiSelectData).filter((e: any) =>
    e?.hasOwnProperty("value")
      ? e?.value?.toString()?.length > 0
      : e?.toString()?.length > 0
  ).length;

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {data?.label !== "Select..." ? (
            <CircularAvatar
              name={data?.label}
              image={data?.image && data?.image}
            />
          ) : (
            <></>
          )}
          {data?.label}
        </div>
      </components.Option>
    );
  };

  const clearFilter = () => {
    resetFilter();
    handleFilterClear();
  };

  const empty = () => {
    const { leadAssignedTo, meetingAssignedTo , meetingStatus }: any = multiSelectData;
    setFilterValue({
      leadAssignedTo,
      meetingAssignedTo,
      meetingStatus
    });
  };
  const resetFilter = () => {
    setFilterValue({
      leadAssignedTo: { name: "select...", value: "" },
      meetingAssignedTo: { name: "select...", value: "" },
      meetingStatus:{name:"select...",value:""}
    });
  };
  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "100%",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "100%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "100%",
      // position: 'absolute'
    }),
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        filterCount === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={filterCount !== 0 ? FilterIcon : filterBlackIcon} alt="" />
        <span className={filterCount !== 0 ? "filter-count" : ""}>
          <span>{filterCount !== 0 ? filterCount : ""}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />
        {/* <span>Filter Data For Lead Received On</span> */}


        <div className="row">
        <div className="col-md-12">
        <label className='mb-1' htmlFor='Lead Assigned To'>Lead Assigned To</label>
                    <Select
                        options={finalUserList}
                        value={filterValue?.leadAssignedTo}
                        components={{ Option }}
                        onChange={(e:any)=>setFilterValue((prev:any)=>({...prev,leadAssignedTo:e}))}
                        isSearchable={true}
                        isLoading={fetching && leadText?.length > 0}
                        onMenuClose={() => setoffset(0)}
                        onMenuScrollToBottom={(e: any) => checkBottom()}
                        onInputChange={(e) => {
                            setText(e)
                            setLeadText(e)
                        }}
                    />
                    </div>
        </div>

        <div className="row">
          <div className="col-md-12">
          <label htmlFor='Meeting Assigned To'>Meeting Assigned To</label>
                    <Select
                        options={finalUserList}
                        value={filterValue?.meetingAssignedTo}
                        components={{ Option }}
                        onChange={(e:any)=>setFilterValue((prev:any)=>({...prev,meetingAssignedTo:e}))}
                        isSearchable={true}
                        isLoading={fetching&&meetingText?.length>0}
                        onMenuClose={() => setoffset(0)}
                        onMenuScrollToBottom={(e: any) => checkBottom()}
                        onInputChange={(e:any)=>{setText(e)
                            setMeetingText(e)}}
                    />
          </div>
       
        </div>

        <div className="row">
          <div className=" col-md-12 mt-3">
            <label
              className="mb-1"
              htmlFor="Stage"
              style={{ fontSize: "14px" }}
            >
              Meet Up Status
            </label>
            <Select
              options={MEET_UP_STATUS}
              styles={dropDownStyle}
              value={
                filterValue?.meetingStatus
              }
              onChange={(e) =>
                setFilterValue((prev: any) => ({ ...prev, meetingStatus: e }))
              }
              isSearchable={true}
            />
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilter();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AllClientMeetUpFilter;
